export default __webpack_public_path__ + "static/media/bio.0bd63b3e.svg";